import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT, BLANK } from '@/router/constant'

const { t } = useI18n()
const multimedia_routes: AppRouteRecordRaw[] = [
  // 多媒体管理
  {
    path: '/multimedia',
    name: 'MediaScreen',
    component: LAYOUT,
    meta: {
      title: t('router.multimediaManagement'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'laptop',
      perCode: 'kedex:multimedia:manage'
    },
    children: [
      // 快速发布
      {
        path: 'program-release',
        name: 'quickRelease',
        component: BLANK,
        redirect: '/multimedia/program-release/index',
        meta: {
          title: t('router.programRelease'),
          hideBreadcrumb: true,
          hideMenu: false,
          perCode: 'kedex:multimedia:manage:program:publish'
        },
        children: [
          {
            path: 'index',
            name: 'program-release-list',
            component: () => import('@/views/multimediaManage/program-release/index.vue'),
            meta: {
              title: t('router.programRelease'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          }
        ]
      },
      // 发布管理
      {
        path: 'release-manage',
        name: 'releaseManagement',
        component: BLANK,
        redirect: '/multimedia/release-manage/index',
        meta: {
          title: t('router.releaseManage'),
          hideBreadcrumb: true,
          hideMenu: false,
          perCode: 'kedex:multimedia:publish:manage'
        },
        children: [
          {
            path: 'index',
            name: 'release-manage-list',
            component: () => import('@/views/multimediaManage/release-manage/index.vue'),
            meta: {
              title: t('router.releaseManage'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          },
          // 发布管理-发布列表-编辑
          {
            path: 'publishList-editor',
            name: 'publishList-editor',
            component: () => import('@/views/multimediaManage/release-manage/publishEditor.vue'),
            meta: {
              title: t('router.releaseManage'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          },
          // 发布管理-发布列表-查看
          {
            path: 'publishList-check',
            name: 'publishList-check',
            component: () => import('@/views/multimediaManage/release-manage/checkDetail.vue'),
            meta: {
              title: t('router.releaseManage'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          }
        ]
      },
      // 素材管理
      {
        path: 'material-management',
        name: 'materialManagement',
        component: BLANK,
        redirect: '/multimedia/material-management/index',
        meta: {
          title: t('router.materialManage'),
          hideBreadcrumb: true,
          hideMenu: false,
          perCode: 'kedex:multimedia:resource:manage'
        },
        children: [
          {
            path: 'index',
            name: 'material-management-list',
            component: () => import('@/views/multimediaManage/material-manage/index.vue'),
            meta: {
              title: t('router.releaseManage'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          }
        ]
      },
      // 节目管理
      {
        path: 'program-manage',
        name: 'programManagement',
        component: BLANK,
        redirect: '/multimedia/program-manage/index',
        meta: {
          title: t('router.programManage'),
          hideBreadcrumb: true,
          hideMenu: false,
          perCode: 'kedex:multimedia:manage:program'
        },
        children: [
          {
            path: 'index',
            name: 'program-manage-list',
            component: () => import('@/views/multimediaManage/program-manage/index.vue'),
            meta: {
              title: t('router.programManage'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          },
          // 节目发布-新建
          {
            path: 'new-program',
            name: 'new-program',
            component: () => import('@/views/multimediaManage/program-release/newProgram.vue'),
            meta: {
              title: t('router.programRelease'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          }
        ]
      },
      // 终端设置
      {
        path: 'system-setting',
        name: 'MediaScreenSettings',
        component: BLANK,
        redirect: '/multimedia/system-setting/index',
        meta: {
          title: t('router.terminalSetting'),
          hideBreadcrumb: true,
          hideMenu: false,
          perCode: 'kedex:multimedia:manage:system'
        },
        children: [
          {
            path: 'index',
            name: 'system-setting-list',
            component: () => import('@/views/multimediaManage/system-setting/index.vue'),
            meta: {
              title: t('router.programManage'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          }
        ]
      }
    ]
  }
]

export default multimedia_routes
